interface UACWarningProps {
  tool: string;
}

/**
 * Pre-install heads-up card for Windows — warns the user once that a
 * UAC dialog is about to appear. Setting expectations is the entire
 * purpose; the actual elevation prompt is unavoidable.
 */
export function UACWarning({ tool }: UACWarningProps) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-gold/40 bg-gold/10 px-4 py-3.5">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-surface text-gold">
        {/* Windows-defender-style shield glyph (subtle, not alarming) */}
        <svg viewBox="0 0 24 24" fill="none" className="h-4.5 w-4.5">
          <path
            d="M12 3.2 4.5 5.8v5.1c0 4.2 3 8 7.5 9.5 4.5-1.5 7.5-5.3 7.5-9.5V5.8L12 3.2Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path
            d="m8.5 12 2.3 2.3L15.8 9"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[14px] font-medium text-space">
          Windows will ask permission once
        </p>
        <p className="mt-0.5 text-[12px] font-medium leading-snug tracking-[0.04em] text-space-50">
          Installing {tool} needs administrator access. Click{" "}
          <span className="font-medium text-space">Yes</span> when Windows
          prompts — you'll only see this the first time.
        </p>
      </div>
    </div>
  );
}
